<script lang="ts" setup>
import type { Component, Page } from '@bloomreach/spa-sdk'
import { computed, useTemplateRef } from 'vue'
import { useBrxmData } from '../../composables/useBrxmData'
import { ETitleBlockSizes } from './ts/types'
import { useVisibilityTracking } from '@/cms-ui/composables/useAnalytics'

const props = defineProps<{
    component: Component
    page: Page
}>()
const data = useBrxmData(props, 'TITLE_BLOCK')
const titleBlockRef = useTemplateRef('titleBlockRef')

const isPreview = computed(() => props.page.isPreview())
const documentRef = computed(() => props.component.getModels().document)
const document = computed(() => documentRef.value && props.page.getContent<Document>(documentRef.value))

const paddingClass = computed(() => {
    if (
        (data?.value?.size === ETitleBlockSizes.H1 || data?.value?.size === ETitleBlockSizes.H2) &&
        data?.value?.title
    ) {
        return 'pt-large'
    }
    return 'pt-medium'
})

useVisibilityTracking(titleBlockRef, 'TitleBlock', data?.value?.title || 'TitleBlock')
</script>

<template>
    <section
        ref="titleBlockRef"
        class="space-standard space-title relative"
        :class="[paddingClass, { 'has-edit-button': isPreview }]"
    >
        <BrManageContentButton :content="document" />
        <div class="container-grid container">
            <TitleBlockPartsTitleBlockComponent
                v-if="data"
                :dark="data?.darkmode"
                :badges="data?.badges"
                :heading="data?.title"
                :seo-heading-size="data?.seoHeadingSize?.value"
                :subheading="data?.subtitle"
                :paragraph="data?.paragraph?.value"
                :heading-block-aligment="data?.alignment"
                :heading-block-size="data?.size"
            />
        </div>
    </section>
</template>

<style scoped>
.pt-large {
  @apply pt-xl lg:pt-2xl;
}

.pt-medium {
  @apply pt-md md:pt-lg lg:pt-xl;
}
</style>
